import { render, staticRenderFns } from "./NavDrawerItems.vue?vue&type=template&id=6301a9a8&scoped=true&"
import script from "./NavDrawerItems.vue?vue&type=script&lang=ts&"
export * from "./NavDrawerItems.vue?vue&type=script&lang=ts&"
import style0 from "./NavDrawerItems.vue?vue&type=style&index=0&id=6301a9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6301a9a8",
  null
  
)

export default component.exports
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDrawer});
